import type { ReactNode, SVGProps } from "react";

export function OutboundPaymentIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="16"
			viewBox="-2.9 -2.9 17 17"
			width="16"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M10.6001 4.34996H0.600098L4.0376 0.600098"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
			<path
				d="M0.600098 6.8501H10.6001L7.1626 10.6"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.2"
			/>
		</svg>
	);
}
